import { Typography } from "@mui/material";

export default function ConditionsAnswer({ text }: { text: string }) {
  return (
    <Typography
      component="p"
      data-testid="conditions-answer"
      sx={{
        color: "ink.main",
        fontSize: { xs: "0.98rem", md: "1.05rem" },
        lineHeight: 1.7,
        maxWidth: 780,
        mb: 1.25,
      }}
    >
      {text}
    </Typography>
  );
}
